import { Base } from "./base/components/base"
import { Div } from "./base/components/native/div"
import { CENTER } from "./base/helpers/style"

export const Notification = () => {
    const base = Base()
    const title = Div('نسخه جدیدی از برنامه موجود است')
    const reload = Div('به روز رسانی')
    base.append(title, reload)

    base.el.setAttribute('id', 'notification')
    reload.el.setAttribute('id', 'reload')

    base.cssClass({
        position: 'fixed',
        bottom: '0',
        right: '0',
        width: '100%',
        height: '50px',
        backgroundColor: '#222',
        zIndex: '99999',
        direction: 'rtl',
        color: '#a5a5a5',
        ...CENTER,
        display: 'none'
    })

    reload.cssClass({
        marginRight: '10px',
        color: 'white'
    })

    return base
}